require('./src/gm.datepickerMultiSelect');
module.exports = 'gm.datepickerMultiSelect';
